import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {}

const BackButton: React.FC<Props> = (props: Props) => {
  const { t, i18n } = useTranslation();
  return (
    <StyledButton {...props} className="text-sm font-medium">
      <span>&lt; {t('Back')}</span>
    </StyledButton>
  );
};

export default BackButton;

const StyledButton = styled.button`
  min-width: 2.625rem;
`;
